import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import './CompanyAutoComplete.css';

class ModelAutoComplete extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';
    this.state = {
      searchTerm,
      target: this.filterModels(searchTerm),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchTerm !== prevProps.searchTerm) {
      this.setState({ searchTerm: this.props.searchTerm || '' });
    }
  }

  filterModels = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    const { models } = this.props;
    return models.filter(model => {
      return model.name.toLowerCase().slice(0, inputLength) === inputValue;
    });
  };

  getModelValue = model => model.name;

  renderSuggestion = model => <div>{model.name}</div>;

  onChange = (event, { newValue }) => {
    if (newValue === '') {
      this.props.onChange({ name: 'model', value: null, suggestion: null });
    }
    this.setState({
      searchTerm: newValue,
    });
  };

  // Autosuggest will call this function every time you need to update target.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      target: this.filterModels(value),
    });
  };

  // Autosuggest will call this function every time you need to clear target.
  onSuggestionsClearRequested = () => {
    this.setState({
      target: [],
    });
  };

  onModelSelected = (ev, { suggestion, suggestionValue }) => {
    const evObj = { name: 'model', value: suggestionValue, suggestion };
    this.props.onChange(evObj);
  };

  onKeyPress = e => {
    if (e.key === 'Enter') {
      const { models, userAutocomplete } = this.props;
      let suggestion = !userAutocomplete
        ? models.filter(item => item.name === e.currentTarget.value)
        : models.filter(item => item.email === e.currentTarget.value);
      this.props.onChange({
        name: 'model',
        value: e.currentTarget.value,
        suggestion: { ...suggestion[0] },
      });
    }
  };

  render() {
    const { searchTerm, target } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: this.props.placeholder || 'Search Model...',
      disabled: this.props.isDisabled || this.props.editStatus,
      value: searchTerm,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      name: 'model',
      requires: 'true',
      type: 'text',
      className: 'form-control',
    };

    // Finally, render it!
    return (
      <div className={this.props.className || 'autocomplete-container'}>
        <Autosuggest
          suggestions={target}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getModelValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onModelSelected}
        />
      </div>
    );
  }
}

export default ModelAutoComplete;
